export default function (md) {
  md.renderer.rules.strong_open = () => '<b>'
  md.renderer.rules.strong_close = () => '</b>'
}